import { ActionReducerMap, MetaReducer } from '@ngrx/store'
import { environment } from '../../../../environments/environment'
import * as fromApp from '../../apps/app.reducer'
import * as fromAuth from '../../auth/auth.reducer'

export interface State {
  [fromAuth.authFeatureKey]: fromAuth.AuthState
  [fromApp.appFeatureKey]: fromApp.State
}

export const reducers: ActionReducerMap<State> = {
  [fromAuth.authFeatureKey]: fromAuth.reducer,
  [fromApp.appFeatureKey]: fromApp.reducer,
}

export const metaReducers: MetaReducer<State>[] = !environment.production ? [] : []
